import camelCase from 'lodash/camelCase';

const removeBannerPrefix = (key, bannerId) => key.replace(`banner_${bannerId}_`, '');

const isLink = (key, bannerId) => {
    const parsedKey = removeBannerPrefix(key, bannerId);

    return parsedKey.startsWith('link_');
};

const isHref = (key, bannerId) => {
    const parsedKey = removeBannerPrefix(key, bannerId);

    return parsedKey.startsWith('link_') && parsedKey.endsWith('_href');
};

const getLinkId = (key, bannerId) => {
    const parsedKey = removeBannerPrefix(key, bannerId);
    const linkPattern = /link_([0-9]+)/;

    return parsedKey.match(linkPattern)?.[1];
};

export const parsePromoBarsData = (promoBarsData) => {
    const {
        activeId,
        content: { banner: banners },
        ...dataNotToParse
    } = promoBarsData;
    const parsedBanners = Object.entries(banners).reduce((mainAccumulator, [bannerKey, banner]) => {
        const bannerId = parseInt(bannerKey, 10);

        return [
            ...mainAccumulator,
            {
                // parse keys that are not part of link data
                ...Object.entries(banner)
                    .filter(([key]) => !isLink(key, bannerId))
                    .reduce((prev, [key, value]) => {
                        const parsedKey = removeBannerPrefix(key, bannerId);
                        const formattedKey = camelCase(parsedKey);

                        return { ...prev, [formattedKey]: value };
                    }, []),
                // parse link data
                links: Object.keys(banner)
                    .filter(key => isHref(key, bannerId))
                    .reduce((prev, key) => {
                        const linkId = getLinkId(key, bannerId);

                        return [
                            ...prev,
                            {
                                url: banner[`banner_${bannerId}_link_${linkId}_href`],
                                name: banner[`banner_${bannerId}_link_${linkId}_text`]
                            }
                        ];
                    }, [])
            }
        ];
    }, []);

    const parsedData = {
        ...dataNotToParse,
        activeId: activeId - 1, // one indexed object -> zero indexed array
        banners: parsedBanners
    };

    return Object.entries(parsedData).reduce((prev, [key, value]) => {
        const formattedKey = camelCase(key);

        return { ...prev, [formattedKey]: value };
    }, {});
};
